<div class="global-container">
    <!-- <h1>Coming Soon !</h1> -->
    <img class="cmng-soon" src = "assets/ComingSoon.png" alt="Coming Soon" />
</div>
